module.exports = __webpack_public_path__ + "static/media/financepic6.974946bc.png";